import { CarouselItem } from '@/components/ui/carousel'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import type { IndustryInterest } from '@/types/learner-portal'
import { INDUSTRIES } from '@/constants/needsAnalysis'

export default function CareerInterestsScreen() {
  const { t } = useTranslation()
  const { industry_interests, toggleIndustry } = useNeedsAnalysis()

  const handleToggle = (industry: IndustryInterest) => {
    toggleIndustry(industry)
  }
  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='career-interests-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.careerInterests.title')}
          </h3>
        </div>

        <div
          role='group'
          aria-labelledby='career-interests-heading'
          className='max-h-[calc(90vh-260px)] space-y-2 overflow-y-auto pr-1 sm:max-h-[320px] sm:pr-2'
        >
          {INDUSTRIES.map((industry) => (
            <Label
              key={industry}
              htmlFor={`industry-${industry}`}
              className={`flex cursor-pointer items-center space-x-2 rounded-lg border p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-3 ${
                industry_interests.includes(industry) ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
              }`}
            >
              <Checkbox
                id={`industry-${industry}`}
                checked={industry_interests.includes(industry)}
                onCheckedChange={() => handleToggle(industry)}
              />
              <span className='flex-1 text-xs font-medium sm:text-sm'>
                {t(`needsAnalysis.careerInterests.industries.${industry}`)}
              </span>
            </Label>
          ))}
        </div>
      </div>
    </CarouselItem>
  )
}
